import React, { useState, useEffect } from "react";
import "./Dashboardcolpagesss.css";
import { useNavigate } from "react-router-dom";

import Navbarcolpagesss from "./Navbarcolpagesss/Navbarcolpagesss";
import Overviewcolpagesss from "./Overviewcolpagesss/Overviewcolpagesss";
import Departofficolpagesss from "./Departofficolpagesss/Departofficolpagesss";
import GrivenaceGraphPage from "./Timetrackercolpagesss/GrivenaceGraphPage";
import Prioritycolpagesss from "./Prioritycolpagesss/Prioritycolpagesss";

import DistrictMap from "./Heatmapcolpagesss/DistrictMap/DistrictMap";
import Notification from "./Heatmapcolpagesss/Notification/Notification";

import { initialComplaintsData } from "../../data/mockData";
import axios from "axios";
import { useTranslation } from "react-i18next";
import PdfUploadButton from "../../PdfUploadButton/PdfUploadButton";


const formatReviewText = (count = 0) => {
  if (count <= 0) return "0 Review";
  return `${count}+ Reviews`;
};


export default function Dashboardcolpagesss() {
  const [loading, setLoading] = useState(true);

  const [notifications, setNotifications] = useState([]);
  const [complaintsData, setComplaintsData] = useState(initialComplaintsData);

  const [activeTab, setActiveTab] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");

  const [blockRatings, setBlockRatings] = useState([]);
  const [tahasilRatings, setTahasilRatings] = useState([]);

  const [gpData, setGpData] = useState([]);
  const [gpAll, setGpAll] = useState([]);
const { t } = useTranslation();
  const [allTabDashboardData, setAllTabDashboardData] = useState([]);

  const [selectedBlock, setSelectedBlock] = useState("Kankadahad");

  const navigate = useNavigate();

  const stars = (count) => "★".repeat(count) + "☆".repeat(5 - count);

  // ---------------------------
  // Fixed lists (always show)
  // ---------------------------
  const FIXED_BLOCKS = [
    "Dhenkanal Sadar",
    "Hindol",
    "Parjang",
    "Bhuban",
    "Kamakhyanagar",
    "Odapada",
    "Gondia",
    "Kankadahad",
  ];

  const FIXED_TAHASIL = [...FIXED_BLOCKS];

  const KANKADAHAD_GP_LIST = [
    "Balikuma", "Bam", "Batagan", "Birasal", "Biribolei",
    "Chandpur", "Dashipur", "Garhapalasuni", "Ghagaramunda",
    "Jhilli", "Kankadahad", "Kantapal", "Kantol", "Kargola",
    "Kerjoli", "Kuturia", "Mahabirod", "Makuakateni",
    "Maruabili", "Pangatira", "Raibol"
  ];

  // ---------------------------
  // FIXED ALL TAB 39 items
  // ---------------------------
  const FIXED_ALL_TAB_LIST = [
    "Office of the Collector and District Magistrate, Collectorate, Dhenkanal",
    "CDM & PHO Office, District Head Quarters Hospital Campus, Dhenkanal",

    "Block Development Office, Dhenkanal Sadar",
    "Block Development Office, Hindol",
    "Block Development Office, Parjang",
    "Block Development Office, Bhuban",
    "Block Development Office, Kamakhyanagar",
    "Block Development Office, Odapada",
    "Block Development Office, Gondia",
    "Block Development Office, Kankadahad",

    "Tahasil Office, Dhenkanal Sadar",
    "Tahasil Office, Gondia",
    "Tahasil Office, Bhuban",
    "Tahasil Office, Kamakhyanagar",
    "Tahasil Office, Kankadahad",
    "Tahasil Office, Parjang",
    "Tahasil Office, Odapada",
    "Tahasil Office, Hindol",

    "Panchayat Office, Balikuma",
    "Panchayat Office, Bam",
    "Panchayat Office, Batagan",
    "Panchayat Office, Birasal",
    "Panchayat Office, Biribolei",
    "Panchayat Office, Chandpur",
    "Panchayat Office, Dashipur",
    "Panchayat Office, Garhapalasuni",
    "Panchayat Office, Ghagaramunda",
    "Panchayat Office, Jhilli",
    "Panchayat Office, Kankadahad",
    "Panchayat Office, Kantapal",
    "Panchayat Office, Kantol",
    "Panchayat Office, Kargola",
    "Panchayat Office, Kerjoli",
    "Panchayat Office, Kuturia",
    "Panchayat Office, Mahabirod",
    "Panchayat Office, Makuakateni",
    "Panchayat Office, Maruabili",
    "Panchayat Office, Pangatira",
    "Panchayat Office, Raibol"
  ];

  // Helper: clean names like "Dhenkanal Sadar block" -> "Dhenkanal Sadar"
  const cleanName = (name) => {
    if (!name) return "";
    return name.replace(/ block/i, "").trim();
  };

  const calculateRating = (feedbacks = []) => {
    const ratings = (feedbacks || [])
      .map((f) => Number(f.overallSatisfaction))
      .filter((n) => !isNaN(n));
    if (ratings.length === 0) return 0;
    const avg = ratings.reduce((a, b) => a + b, 0) / ratings.length;
    return Math.round(avg);
  };

  // ---------------------------
  // Load core feedbacks endpoint
  // ---------------------------
  const loadFeedbackData = async () => {
    try {
      const res = await axios.get("https://d360-backend.vercel.app/api/feedbacks");
      const data = res.data.data || [];

      const blockMap = {};
      const tahasilMap = {};

      data.forEach((fb) => {
        const cleanBlock = fb.block ? cleanName(fb.block) : (fb.feedbacks?.[0]?.block ? cleanName(fb.feedbacks[0].block) : "");
        const cleanTahasil = fb.tahasil ? cleanName(fb.tahasil) : (fb.feedbacks?.[0]?.tahasil ? cleanName(fb.feedbacks[0].tahasil) : "");

        const rating = Number(fb.overallSatisfaction);
        const validRating = isNaN(rating) ? null : rating;

        if (cleanBlock) {
          if (!blockMap[cleanBlock]) blockMap[cleanBlock] = [];
          if (validRating !== null) blockMap[cleanBlock].push(validRating);
        }

        if (cleanTahasil) {
          if (!tahasilMap[cleanTahasil]) tahasilMap[cleanTahasil] = [];
          if (validRating !== null) tahasilMap[cleanTahasil].push(validRating);
        }
      });

      const blockList = FIXED_BLOCKS.map((blk, idx) => {
        const arr = blockMap[blk] || [];
        const avg = arr.length > 0 ? Math.round(arr.reduce((a, b) => a + b, 0) / arr.length) : 0;
        return {
          officeId: idx + 1,
          name: blk,
          rating: avg,
          totalReviews: arr.length,
        };
      });

      const tahasilList = FIXED_TAHASIL.map((th, idx) => {
        const arr = tahasilMap[th] || [];
        const avg = arr.length > 0 ? Math.round(arr.reduce((a, b) => a + b, 0) / arr.length) : 0;
        return {
          officeId: idx + 1,
          name: th,
          rating: avg,
          totalReviews: arr.length,
        };
      });

      setBlockRatings(blockList);
      setTahasilRatings(tahasilList);
    } catch (err) {
      console.error("Error loading dashboard feedback data", err);
      const fallbackBlocks = FIXED_BLOCKS.map((blk, idx) => ({ officeId: idx + 1, name: blk, rating: 0, totalReviews: 0 }));
      const fallbackTahasils = FIXED_TAHASIL.map((th, idx) => ({ officeId: idx + 1, name: th, rating: 0, totalReviews: 0 }));
      setBlockRatings(fallbackBlocks);
      setTahasilRatings(fallbackTahasils);
    }
  };

  // ---------------------------
  // Load GP All for All tab
  // ---------------------------
  const loadGpAllForAllTab = async () => {
    try {
      const res = await axios.get("https://d360-backend.vercel.app/api/feedbacks/gp-wise");
      const allGp = res.data.data || [];

      const finalGpForAll = KANKADAHAD_GP_LIST.map((gpName, idx) => {
        const found = allGp.find((g) => g.gp === gpName);
        return {
          officeId: idx + 1,
          name: gpName,
          rating: found ? calculateRating(found.feedbacks) : 0,
          count: found ? found.count : 0,
        };
      });

      setGpAll(finalGpForAll);
    } catch (err) {
      console.error("Error loading gp-wise for all tab", err);
      const fallback = KANKADAHAD_GP_LIST.map((gpName, idx) => ({ officeId: idx + 1, name: gpName, rating: 0, count: 0 }));
      setGpAll(fallback);
    }
  };

  // --------------------------------
  // GP real loader
  // --------------------------------
  const loadRealGpData = async (blockName) => {
    try {
      const res = await axios.get("https://d360-backend.vercel.app/api/feedbacks/gp-wise");
      const allGp = res.data.data || [];

      if (blockName === "Kankadahad") {
        const formatted = KANKADAHAD_GP_LIST.map((gpName, idx) => {
          const found = allGp.find((g) => g.gp === gpName);
          return {
            officeId: idx + 1,
            name: gpName,
            rating: found ? calculateRating(found.feedbacks) : 0,
            count: found ? found.count : 0,
          };
        });
        setGpData(formatted);
        return;
      }

      const filtered = allGp.filter((item) => cleanName(item.feedbacks?.[0]?.block) === blockName);

      if (filtered.length === 0) {
        setGpData([]);
        return;
      }

      const formatted = filtered.map((item, idx) => ({
        officeId: idx + 1,
        name: item.gp,
        rating: calculateRating(item.feedbacks),
        count: item.count || 0,
      }));

      setGpData(formatted);
    } catch (err) {
      console.error("Error loading GP-wise dashboard data", err);
      setGpData([]);
    }
  };

  // ---------------------------
  // Load All Tab 39 fixed offices
  // ---------------------------
  const loadDashboardAllTab = async () => {
    try {
      const res = await axios.get("https://d360-backend.vercel.app/api/feedbacks");
      const all = res.data.data || [];

      const officeMap = {};
      all.forEach((fb) => {
        if (!officeMap[fb.officeName]) officeMap[fb.officeName] = [];
        officeMap[fb.officeName].push(fb);
      });

      const finalList = FIXED_ALL_TAB_LIST.map((office, idx) => {
        const feedbacks = officeMap[office] || [];
        return {
          officeId: idx + 1,
          name: office,
          rating: calculateRating(feedbacks),
          count: feedbacks.length,
        };
      });

      setAllTabDashboardData(finalList);
    } catch (err) {
      console.error("Error loading dashboard ALL tab data", err);
      const fallback = FIXED_ALL_TAB_LIST.map((office, idx) => ({ officeId: idx + 1, name: office, rating: 0, count: 0 }));
      setAllTabDashboardData(fallback);
    }
  };

  useEffect(() => {
    // loadFeedbackData();
    // loadDashboardAllTab();
    // loadGpAllForAllTab();
    setTimeout(() => setLoading(false), 800);
  }, []);

  // useEffect(() => {
  //   if (activeTab === "GPs") {
  //     loadRealGpData(selectedBlock);
  //   }
  // }, [activeTab, selectedBlock]);

  const currentData =
    activeTab === "All"
      ? allTabDashboardData
      : activeTab === "Block"
      ? blockRatings
      : activeTab === "Tahasil"
      ? tahasilRatings
      : activeTab === "GPs"
      ? gpData
      : [];

  const sortedByOfficeId = [...currentData].sort((a, b) => (a.officeId || 0) - (b.officeId || 0));

  const openFeedbackList = (name) => {
    navigate("/feedback-list", { state: { officeName: name } });
  };

  if (loading) {
    return (
      <div className="dashboard-loading">
        <div className="dashboard-spinner"></div>
        <p>{t("common.loading")}</p>
      </div>
    );
  }

  return (
    <div className="dashboardcolpagesss-wrapper">
      <Navbarcolpagesss />

      <div className="dashboardcolpagesss-content">
        {/* <div className="feedback-section">
          <h2 className="blockfeedbackpage-title">Feedback</h2>

          <div className="blockfeedbackpage-search-box">
            <input
              type="text"
              placeholder="By Office……"
              className="blockfeedbackpage-search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span className="blockfeedbackpage-search-icon">
              <FiSearch size={18} />
            </span>
          </div>

          <div className="blockfeedbackpage-tabs">
            {["All", "Block", "Tahasil", "GPs", "Others"].map((tab) => (
              <button
                key={tab}
                className={activeTab === tab ? "blockfeedbackpage-tab-active" : "blockfeedbackpage-tab"}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          {activeTab === "GPs" && (
            <div className="blockfeedbackpage-gp-header">
              <span className="blockfeedbackpage-green-tag">{selectedBlock}</span>

              <div className="gp-dropdown-container">
                <label className="gp-dropdown-label">Search Block-wise </label>

                <select
                  value={selectedBlock}
                  onChange={(e) => setSelectedBlock(e.target.value)}
                  className="blockfeedbackpage-select-gp"
                >
                  <option>Dhenkanal Sadar</option>
                  <option>Kankadahad</option>
                  <option>Gondia</option>
                  <option>Odapada</option>
                  <option>Kamakhyanagar</option>
                  <option>Bhuban</option>
                  <option>Parjang</option>
                  <option>Hindol</option>
                </select>
              </div>
            </div>
          )}

          <div className="blockfeedbackpage-grid">
            {activeTab === "GPs" && gpData.length === 0 ? (
              <p className="no-gp-message">No reviews available for this block.</p>
            ) : (
              sortedByOfficeId
                .filter((item) =>
                  (item.name || "").toLowerCase().includes(searchTerm.toLowerCase())
                )
                .slice(0, 4)
                .map((item, i) => (
                  <div
                    className="blockfeedbackpage-card"
                    key={item.officeId ?? i}
                    onClick={() => openFeedbackList(item.name)}
                  >
                    <h3 className="blockfeedbackpage-card-title">{item.name}</h3>

                    <div className="blockfeedbackpage-rating-row">
                      <span className="blockfeedbackpage-stars">
                        {stars(Math.round(item.rating || 0))}
                      </span>

                      <span className="blockfeedbackpage-review-text">
                        {formatReviewText(item.totalReviews || item.count)}
                      </span>
                    </div>

                    <button
                      className="blockfeedbackpage-track-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        openFeedbackList(item.name);
                      }}
                    >
                      Track
                    </button>
                  </div>
                ))
            )}
          </div>

          <span
            className="feedback-readmore"
            onClick={() => navigate("/blockFeedbackPage")}
          >
            Read More
          </span>
        </div> */}

        {/* TOP ROW */}
        <div className="dashboardcolpagesss-toprow">
          <div className="dashboardcolpagesss-overview">
            <Overviewcolpagesss />
            <Prioritycolpagesss />
          </div>

          <div className="dashboardcolpagesss-heatmap">
            <div className="App">
              <div className="app-grid">
                <div className="dashboard-panel"></div>

                <div className="map-panel">
                  <Notification notifications={notifications} />

                  <DistrictMap
                    complaintsData={complaintsData}
                    setComplaintsData={setComplaintsData}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM */}
        <div className="dashboardcolpagesss-row">
          <Departofficolpagesss />
          <GrivenaceGraphPage />
        </div>
        <PdfUploadButton/>
      </div>
    </div>
  );
}
